/**
 * The CRM's chime and desktop notification (crm/src/public/shared/runner-events.js
 * playNotifyChime / postOsNotification), for the React Chats page.
 */
import { isDesktop, openFromNotification } from '../desktop/desktopBridge'
import type { LiveNotification } from './ChatsDeps'

let audio: AudioContext | null = null

function chime() {
  if (document.hidden) return
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!Ctx) return
    audio ??= new Ctx()
    if (audio.state === 'suspended') void audio.resume()
    const t = audio.currentTime
    for (const [freq, start, dur] of [
      [523.25, t, 0.11],
      [659.25, t + 0.13, 0.15],
    ] as const) {
      const osc = audio.createOscillator()
      const gain = audio.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      gain.gain.setValueAtTime(0.0001, start)
      gain.gain.exponentialRampToValueAtTime(0.14, start + 0.015)
      gain.gain.exponentialRampToValueAtTime(0.0001, start + dur)
      osc.connect(gain)
      gain.connect(audio.destination)
      osc.start(start)
      osc.stop(start + dur)
    }
  } catch {
    /* no audio */
  }
}

export async function notifyPerson(n: LiveNotification) {
  chime()
  if (typeof Notification === 'undefined') return
  try {
    if (Notification.permission === 'default') await Notification.requestPermission()
    if (Notification.permission !== 'granted') return
    const note = new Notification(`Onlymind — ${n.title}`, { body: n.body.slice(0, 240), tag: n.tag, icon: '/crm/crm-notify-icon.svg' })
    // In the Desktop client a click brings the window back and opens the chat (ADR 0033).
    if (isDesktop()) {
      note.onclick = () => {
        note.close()
        openFromNotification(n.href)
      }
    }
  } catch {
    /* blocked */
  }
}
